// User Model
import { Model } from '@vuex-orm/core';

export default class Message extends Model {
	// This is the name used as module name of the Vuex Store.

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			name: this.attr(''),
			user_id: this.attr(null),
			created_at: this.attr(null),
			deleted_at: this.attr(null),
			mine: this.attr(false),
			body: this.attr(''),
			thread_id: this.attr(null),
			attachments: this.attr([]),
			new: this.attr(false),
			not_send: this.attr(false),
			image_preview: this.attr([]),
			fake_thread_id: this.attr(null),
			fake: this.attr(false),
		};
	}

}

Message.entity = 'messages';
Message.apiConfig = {
	actions: {
		fetchByThreadId(threadId, pageId = 1) {
			const params = new URLSearchParams();
			params.append('page', pageId);

			return new Promise((resolve, reject) => {
				this.get(`/api/v3/inbox/${threadId}/messages`, {
					params,
					dataTransformer: (response) => response.data.data,
				}).then((response) => {
					resolve(response);
				}).catch((error) => {
					reject(error.response.data);
				});
			});
		},
		send(threadId, message) {
			return new Promise(async (resolve) => {

				const genIdArr = Thread.find(threadId).sent_message_ids;
				const genId = Math.floor((Math.random() * 99999) + 1);
				genIdArr.push(genId);

				Thread.update({
					where: threadId,
					data: {
						sent_message_ids: genIdArr
					}
				});

				message.id = genId;
				message.thread_id = threadId;
				message.body = message.message;
				message.user_id = user.id;
				message.mine = true;
				message.not_send = true;
				message.new = true;

				const now = new Date();
				//2021-06-07 10:31:07
				const created_at = `${ now.getFullYear() }-${ now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1 }-${ now.getDate() < 10 ? '0' + now.getDate() : now.getDate() } ${ now.toLocaleString('nl-NL').split(' ')[1] }`;

				message.created_at = created_at;

				Message.insert({
					data: [
						message
					],
				});


				this.post(`/api/v3/inbox/${threadId}/messages`, message, {
					save: false
				}).then((response) => {
					resolve(response);
				});
			});

		},
		deleteMessage(threadId, messageId) {
			return new Promise((resolve) => {
				this.delete(`/api/v3/inbox/${threadId}/messages/${messageId}`, {
					save: false,
					dataTransformer: (response) => response.data.data,
				}).then((response) => {
					const date = new Date();
					const dateFormatted = date.toLocaleDateString().replaceAll('/','-');
					const time = date.toLocaleTimeString();
					const deleted_at = dateFormatted +' ' + time;

					Message.update({
						where: messageId,
						data: {
							deleted_at
						}
					});
				
					resolve(response);
				});
			});
		},
	},
};

window.Message = Message;
